import React, { useEffect, useRef, Component, useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory, useParams, Link } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { Watch } from "react-loader-spinner";

const BlogByTags = () => {
  let history = useHistory();
  const didMountRef = useRef(true);
  const { slug } = useParams();
  let apiServices = new ApiService();
  const [blogsData, setBlogsData] = useState([]);
  const [baseUrl, setBaseUrl] = useState('');
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  useEffect(() => {
    if (didMountRef.current) {
      setSpinnerLoading(true);
      const dataString = {
        "slug": slug
      }
      apiServices.getblogbytags(dataString).then(res => {
        if (res.data.status == 'success') {
          setBlogsData(res.data.data);
          setBaseUrl(res.data.baseurl);
          setSpinnerLoading(false);
        }
      })
    }
    didMountRef.current = false;
  });
  return (
    <div>
      <Header />
      <section>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className="section-title tx-center">
            <h2>Keep Learning, Keep Growing</h2>
            <p>8+ million Zerodha clients contribute to over 15% of all retail order volumes in India daily by trading and investing</p>
          </div>
          <div className="row">
            {
              blogsData.map(key =>
                <div className="col-md-4" >
                  <div className="blogbox">
                    <div className="blogbox-img">
                      <Link to={`/blog-detail/${key.blog_slug}`}>
                        {
                          key.blog_image != '' ? <img src={baseUrl + key.blog_image} /> : <img src="https://www.codexocoder.com/2022/goalstox/public/img/uploads/blog_image/1649328888.webp" />
                        }
                      </Link>
                    </div>
                    <div className="blog-meta">
                      <div className="blog-meta-date">{key.created_at} | by Goalstox</div>
                      <div className="blog-meta-category">
                        <ul>
                          {
                            key.blog_category_id.map(cat => <li><Link exact to={`/blog-category/${cat.category_slug}`} >{cat.category_name}</Link></li>)
                          }
                       </ul>
                      </div>
                    </div>
                    <div className="blogbox-title">{key.blog_name}</div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default BlogByTags;